'use client';

import React from 'react';
import { Container, Row } from 'reactstrap';
import Image from 'next/image';
import { useEnvContext } from '@/context/envContext';

//import components
import { SearchBar } from '../SearchBar/SearchBar';
import UserNav from '../UserNav/UserNav';
import { pushGTMClickTags } from '@/libs/pushGTMTags/pushGTMTags';
function Header() {
  const {
    cdnEnv
  } = useEnvContext();

  // If cdnEnv is undefined use prods hardcoded url path, will happen on notFoumd page
  const logo = cdnEnv ? `${cdnEnv}/rms/images/techtarget-logo.svg` : 'https://media.techtarget.com/rms/images/techtarget-logo.svg';
  return <Container className={'site-header'} data-bdd={'site-header'} data-sentry-element="Container" data-sentry-component="Header" data-sentry-source-file="Header.tsx">
   <Row className={'header-top'} data-bdd={'header-top'} data-sentry-element="Row" data-sentry-source-file="Header.tsx">
    <a className={'comp-brand text-links-body-color'} href="https://www.techtarget.com/network/" onClick={() => {
        pushGTMClickTags({
          click_element: 'Anchor',
          click_section_ID: 'NONE',
          link_classes: 'comp-brand text-links-body-color',
          link_id: 'NONE',
          link_text: 'TechTarget network',
          link_url: 'https://www.techtarget.com/network/',
          click_category: 'NONE',
          click_destination: 'TechTarget Network',
          click_closest_href: 'NONE'
        });
      }}>
     TechTarget Network
    </a>
    <UserNav data-sentry-element="UserNav" data-sentry-source-file="Header.tsx" />
   </Row>

   <Row className={'header-bottom'} data-bdd={'header-bottom'} data-sentry-element="Row" data-sentry-source-file="Header.tsx">
    <div className={'tt-logo'} data-bdd={'site-logo'}>
     <Image src={logo} width={'84'} height={'44'} priority={true} alt={'Techtarget logo'} data-sentry-element="Image" data-sentry-source-file="Header.tsx" />
     <p className={'logo-strap'} data-bdd={'logo-strapline'}>
      <span>Content</span>
      <span> Hub</span>
     </p>
    </div>

    <SearchBar data-sentry-element="SearchBar" data-sentry-source-file="Header.tsx" />
   </Row>
  </Container>;
}
export default Header;